import request from './request'

//登录接口
export function login(data) {
  return request({
    url: '/users/users!LoginUserByChat.action',
    method: 'post',
    params: data,
  })
}

//管理员登录接口
export function caregiverLogin(data) {
  return request({
    url: '/caregiverAdmin/caregiver-admin!login.action',
    method: 'post',
    params: data,
  })
}

//医院登录接口
export function hospitalLogin(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!login.action',
    method: 'post',
    params: data,
  })
}

//医院注册接口
export function hospitalRegister(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!addHospital.action',
    method: 'post',
    params: data,
  })
}
//医院信息更新接口
export function updateHospital(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!updateHospital.action',
    method: 'post',
    params: data,
  })
}

export function loginnocode(data) {
  return request({
    url: '/users/users!LoginUserByChat1.action',
    method: 'post',
    params: data,
  })
}

//支付宝购买
export function alipayPageOrderByPhone(data) {
  return request({
    url: '/app/ali-pay!toPayChatHtml.action',
    method: 'post',
    params: data,
  })
}

export function alipayPageOrderByPC(data) {
  return request({
    url: '/app/ali-pay!alipayPageOrder.action',
    method: 'post',
    params: data,
  })
}

export function isNumberOfTimes(data) {
  return request({
    url: '/chat/record/chat-record!isNumberOfTimesByPionts.action',
    method: 'post',
    params: data,
  })
}

export function updatePerUser(data) {
  return request({
    url: '/userinfo/user-info!updatePerUser.action',
    method: 'post',
    params: data,
  })
}

//获取个人信息
export function getPerUserById(data) {
  return request({
    url: '/users/users!getPerUserById.action',
    method: 'post',
    params: data,
  })
}

export function sendCodeByAli(data) {
  return request({
    url: '/userinfo/user-info!sendCodeByAli.action',
    method: 'get',
    params: data,
  })
}

export function getUserInfoByUserId(data) {
  return request({
    url: '/support/per-user!getUserInfoByUserId.action',
    method: 'post',
    params: data,
  })
}

export function getTranslateText(data) {
  return request({
    url: '/chat/record/chat-record!getTranslateText.action',
    method: 'post',
    params: data,
  })
}

export function getChatImgDetail(data) {
  return request({
    url: '/chat/record/chat-record!getChatImgDetail.action',
    method: 'post',
    params: data,
  })
}

export function getBuyDetailByUserId(data) {
  return request({
    url: '/support/per-user!getBuyDetailByUserId.action',
    method: 'post',
    params: data,
  })
}

export function getAndroidToken() {
  return request({
    url: '/drama/drama!getAndroidToken.action',
    method: 'post',
  })
}

export function doUploadAudioForAsi(data) {
  return request({
    url: '/show/room/show-room!doUploadAudioForAsi.action',
    method: 'post',
    data: data,
  })
}

export function getUserMoneyDetails(data) {
  return request({
    url: '/chat/record/chat-record!getUserMoneyDetailsYAddress.action',
    method: 'post',
    params: data,
  })
}

export function alipayPageOrderByFree(data) {
  return request({
    url: '/app/ali-pay!alipayPageOrderByFree.action',
    method: 'post',
    params: data,
  })
}

export function vueUnifiedOrder(data) {
  return request({
    url: '/app/wx-app-pay!vueUnifiedOrder.action',
    method: 'post',
    params: data,
  })
}

export function getOpenIdJs(data) {
  return request({
    url: '/users/users!getOpenIdJs.action',
    method: 'post',
    params: data,
  })
}

export function getWechatSign(data) {
  return request({
    url: '/app/wx-js-sdk!getWechatSign.action',
    method: 'post',
    params: data,
  })
}

export function loginOutToChat(data) {
  return request({
    url: '/chat/chat-home!loginOutToChat.action',
    method: 'post',
    params: data,
  })
}

//获取服务对象列表
export function getServiceTargetList(data) {
  return request({
    url: '/careServiceTarget/care-service-target!getServiceTargetList.action',
    method: 'post',
    params: data,
  })
}

//批量导入服务对象
export function importServiceTargets(data) {
  return request({
    url: '/careServiceTarget/import/care-service-target-import!importServiceTargets.action',
    method: 'post',
    data: data,
  })
}

//编辑服务对象
export function addServiceTarget(data) {
  return request({
    url: '/careServiceTarget/care-service-target!addServiceTarget.action',
    method: 'post',
    params: data,
  })
}

// 服务对象出院
export function updateDischargeServiceTarget(data) {
  return request({
    url: '/careServiceTarget/care-service-target!updateDischargeServiceTarget.action',
    method: 'post',
    params: data,
  })
}

// 获取服务对象出院历史记录
export function getDischargeRecords(params) {
  return request({
    url: '/careServiceTarget/care-service-target!getDischargeRecords.action',
    method: 'get',
    params: params,
  })
}

// 授权医院或护工公司继续查看出院服务对象信息
export function updateAuthorizeTarget(data) {
  return request({
    url: '/careServiceTarget/care-service-target!updateAuthorizeTarget.action',
    method: 'post',
    params: data,
  })
}

// 获取服务对象已授权列表
export function getTargetAuthorizations(params) {
  return request({
    url: '/careServiceTarget/care-service-target!getTargetAuthorizations.action',
    method: 'get',
    params: params,
  })
}

// 撤销授权
export function updateRevokeAuthorization(data) {
  return request({
    url: '/careServiceTarget/care-service-target!updateRevokeAuthorization.action',
    method: 'post',
    params: data,
  })
}

//新增服务对象导入接口
export function addServiceTargets(data) {
  return request({
    url: '/careServiceTarget/import/care-service-target-import!addServiceTargets.action',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

//获取护工列表
export function getHospitalCaregiverList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getHospitalCaregiverList.action',
    method: 'post',
    params: data,
  })
}

//获取护工详情
export function getCaregiverDetail(data) {
  return request({
    url: '/caregiver/caregiver!getCaregiverDetail.action',
    method: 'post',
    params: data,
  })
}

//添加护工
export function addCaregiver(data) {
  return request({
    url: '/caregiver/caregiver!addCaregiver.action',
    method: 'post',
    params: data,
  })
}

//删除护工
export function deleteCaregiver(data) {
  return request({
    url: '/caregiver/caregiver!deleteCaregiver.action',
    method: 'post',
    params: data,
  })
}

//审核护工
export function auditCaregiver(data) {
  return request({
    url: '/caregiver/caregiver!auditCaregiver.action',
    method: 'post',
    params: data,
  })
}

//批量导入护工
export function addImportCaregivers(data) {
  return request({
    url: '/caregiver/import/caregiver-import!addImportCaregivers.action',
    method: 'post',
    data: data,
  })
}

//获取用户列表
export function getUserList(data) {
  return request({
    url: '/caregiverUser/caregiver-user!getUserList.action',
    method: 'post',
    params: data,
  })
}
//删除用户
export function deleteUser(data) {
  return request({
    url: '/caregiverUser/caregiver-user!deleteUser.action',
    method: 'post',
    params: data,
  })
}
//删除用户
export function deletempyeeUser(data) {
  return request({
    url: '/caregiver/hospitalUser/caregiver-hospital-user!deleteUser.action',
    method: 'post',
    params: data,
  })
}

//获取护理记录列表
export function getCareRecordList(data) {
  return request({
    url: '/caregiver/care/care-record!getCareRecordList.action',
    method: 'post',
    params: data,
  })
}

//获取护理记录详情
export function getCareRecordDetail(data) {
  return request({
    url: '/caregiver/care/care-record!getCareRecordDetail.action',
    method: 'post',
    params: data,
  })
}

//获取订单列表
export function getOrderList(data) {
  return request({
    url: '/caregiver/order/caregiver-order!getOrderList.action',
    method: 'post',
    params: data,
  })
}

//获取订单详情
export function getOrderDetail(data) {
  return request({
    url: '/caregiver/order/caregiver-order!getOrderDetail.action',
    method: 'post',
    params: data,
  })
}

//审核终止订单
export function updateReviewTerminateOrder(data) {
  return request({
    url: '/caregiver/order/caregiver-order!updateReviewTerminateOrder.action',
    method: 'post',
    params: data,
  })
}

//获取护工公司列表
export function getCompanyList(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!getCompanyList.action',
    method: 'post',
    params: data,
  })
}

//添加护工公司
export function addCompany(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!addCompany.action',
    method: 'post',
    params: data,
  })
}

//编辑护工公司
export function updateCompany(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!updateCompany.action',
    method: 'post',
    params: data,
  })
}

//删除护工公司
export function deleteCompany(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!deleteCompany.action',
    method: 'post',
    params: data,
  })
}

//获取护工公司详情
export function getCompanyDetail(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!getCompanyDetail.action',
    method: 'post',
    params: data,
  })
}

//终止护工公司合作
export function terminateCompany(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!terminateCompany.action',
    method: 'post',
    params: data,
  })
}

//审核公司关系申请
export function auditCompanyRelation(data) {
  return request({
    url: 'hospital/company/relation/hospital-company-relation!addAuditApplication.action',
    method: 'post',
    params: data,
  })
}

//医院终止与护工公司的合作关系
export function terminatePartnership(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!updateTerminatePartnership.action',
    method: 'post',
    params: data,
  })
}



// 护工离职
export function resignCaregiver(data) {
  return request({
    url: '/caregiver/caregiver!resignCaregiver.action',
    method: 'post',
    params: data,
  })
}
// 护工提交的离职
export function processResignationApplication(data) {
  return request({
    url: '/caregiver/caregiver!processResignationApplication.action',
    method: 'post',
    params: data,
  })
}

// 科室管理相关API
// 添加科室
export function addDepartment(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!addDepartment.action',
    method: 'post',
    params: data,
  })
}

// 更新科室
export function updateDepartment(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!updateDepartment.action',
    method: 'post',
    params: data,
  })
}

// 删除科室
export function deleteDepartment(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!deleteDepartment.action',
    method: 'post',
    params: data,
  })
}

// 获取科室信息
export function getDepartmentById(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!getDepartmentById.action',
    method: 'get',
    params: data,
  })
}

// 分页查询科室列表
export function getDepartmentList(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!getDepartmentList.action',
    method: 'get',
    params: data,
  })
}

// 根据医院ID查询科室列表
export function getDepartmentsByHospitalId(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!getDepartmentsByHospitalId.action',
    method: 'get',
    params: data,
  })
}

// 统计科室数量
export function countDepartmentsByHospitalId(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!countDepartmentsByHospitalId.action',
    method: 'get',
    params: data,
  })
}

// 统计总床位数
export function countTotalBedsByHospitalId(data) {
  return request({
    url: '/caregiver/hospital/department/caregiver-hospital-department!countTotalBedsByHospitalId.action',
    method: 'get',
    params: data,
  })
}

// 批量导入科室
export function importDepartments(data) {
  return request({
    url: '/caregiver/hospital/department/import/caregiver-hospital-department-import!addDepartments.action',
    method: 'post',
    data: data,
  })
}

// 获取医院信息
export function getHospitalInfo(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getHospitalInfo.action',
    method: 'post',
    params: data,
  })
}

// 获取医院订单列表
export function getHospitalOrderList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getHospitalOrderList.action',
    method: 'post',
    params: data,
  })
}

// 获取医院护理对象列表
export function getHospitalServiceTargetList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getHospitalServiceTargetList.action',
    method: 'post',
    params: data,
  })
}



// 获取护理统计数据
export function getCareStatistics(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getCareStatistics.action',
    method: 'post',
    params: data,
  })
}

// 新增服务对象
export function addHospitalServiceTarget(data) {
  return request({
    url: '/hospital/serviceTarget/hospital-service-target!addHospitalServiceTarget.action',
    method: 'post',
    params: data,
  })
}

// 删除服务对象
export function deleteHospitalServiceTarget(data) {
  return request({
    url: '/hospital/serviceTarget/hospital-service-target!deleteHospitalServiceTarget.action',
    method: 'post',
    params: data,
  })
}

// 获取医院已审核的护工公司列表
export function getHospitalApprovedCompanies(data) {
  return request({
    url: '/hospital/company/relation/hospital-company-relation!getHospitalApprovedCompanies.action',
    method: 'post',
    params: data,
  })
}
// 获取医院已审核的护工公司列表
export function getCareReportList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getCareReportList.action',
    method: 'post',
    params: data,
  })
}
//获取健康报告
export function getHealthReportList(data) {
  return request({
    url: '/caregiver/health/health-report!getHealthReportList.action',
    method: 'post',
    params: data,
  })
}
//获取健康报告
export function getCareMonthlyReportList(data) {
  return request({
    url: '/caregiver/service/care-service-record!getCareMonthlyReportList.action',
    method: 'post',
    params: data,
  })
}
//获取健康报告
export function getCareMonthlyReportDetail(data) {
  return request({
    url: '/caregiver/service/care-service-record!getCareMonthlyReportDetail.action',
    method: 'post',
    params: data,
  })
}

//获取检测报告列表
export function getDetectionReportList(data) {
  return request({
    url: '/detection/report/detection-report!getReportList.action',
    method: 'post',
    params: data,
  })
}

//获取综合分析列表
export function getComprehensiveAnalysisList(data) {
  return request({
    url: '/detection/comprehensive/detection-comprehensive-analysis!getAnalysisList.action',
    method: 'get',
    params: data,
  })
}
//获取检测报告详情
export function getDetectionReportDetail(data) {
  return request({
    url: '/detection/report/detection-report!getReportDetail.action',
    method: 'post',
    params: data,
  })
}

//获取综合分析详情
export function getComprehensiveAnalysisDetail(data) {
  return request({
    url: '/detection/comprehensive/detection-comprehensive-analysis!getAnalysisDetail.action',
    method: 'get',
    params: data,
  })
}

// ==================== 活动管理相关接口 ====================

// 获取活动列表
export function getActivityList(data) {
  return request({
    url: '/careActivity/care-activity!getActivityList.action',
    method: 'get',
    params: data,
  })
}

// 获取活动详情
export function getActivityDetail(data) {
  return request({
    url: '/careActivity/care-activity!getActivityDetail.action',
    method: 'get',
    params: data,
  })
}

// 添加/更新活动
export function addActivity(data) {
  return request({
    url: '/careActivity/care-activity!addActivity.action',
    method: 'post',
    params: data,
  })
}

// 发布活动
export function publishActivity(data) {
  return request({
    url: '/careActivity/care-activity!publishActivity.action',
    method: 'post',
    params: data,
  })
}




// 上架下架活动
export function updateActivity(data) {
  return request({
    url: '/careActivity/care-activity!updateActivity.action',
    method: 'post',
    params: data,
  })
}



// 删除活动
export function deleteActivity(data) {
  return request({
    url: '/careActivity/care-activity!deleteActivity.action',
    method: 'post',
    params: data,
  })
}


// 获取报名记录列表
export function getRegistrationList(data) {
  return request({
    url: '/careActivity/care-activity!getRegistrationList.action',
    method: 'get',
    params: data,
  })
}

// 获取报名记录详情
export function getRegistrationDetail(data) {
  return request({
    url: '/careActivity/care-activity!getRegistrationDetail.action',
    method: 'get',
    params: data,
  })
}

// 审核报名
export function updateAuditRegistration(data) {
  return request({
    url: '/careActivity/care-activity!updateAuditRegistration.action',
    method: 'post',
    params: data,
  })
}
// 流程对话记录列表
export function getCareServiceStageDialogList(data) {
  return request({
    url: '/care/flow/care-flow-controller!getCareServiceStageDialogList.action',
    method: 'get',
    params: data,
  })
}

// 健康问答记录列表
export function getQAListForManage(data) {
  return request({
    url: '/caregiverQA/caregiver-question!getQAListForManage.action',
    method: 'get',
    params: data,
  })
}
// 批量导入用户
export function addImportUsers(data) {
  return request({
    url: '/caregiver/hospitalUser/caregiver-hospital-user!addImportUsers.action',
    method: 'post',
    data: data,
  })
}
// 获取职工列表
export function getUserList2(data) {
  return request({
    url: '/caregiver/hospitalUser/caregiver-hospital-user!getUserList.action',
    method: 'post',
    params: data,
  })
}
// 不良事件列表接口
export function getAdverseEventList(data) {
  return request({
    url: '/caregiver/adverseEvent/caregiver-adverse-event!getAdverseEventList.action',
    method: 'post',
    params: data,
  })
}
// 获取职工列表
export function getSatisfactionSurveyList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getSatisfactionSurveyList.action',
    method: 'post',
    params: data,
  })
}
// 抽查列表接口
export function getInspectionRecordList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getInspectionRecordList.action',
    method: 'post',
    params: data,
  })
}
// 获取抽查详情接口
export function getInspectionRecordDetail(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getInspectionRecordDetail.action',
    method: 'post',
    params: data,
  })
}
// 获取满意度调查详情接口
export function getSatisfactionSurveyDetail(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getSatisfactionSurveyDetail.action',
    method: 'post',
    params: data,
  })
}
// 获取不良事件详情
export function getAdverseEventById(data) {
  return request({
    url: '/caregiver/adverseEvent/caregiver-adverse-event!getAdverseEventById.action',
    method: 'post',
    params: data,
  })
}
// 批量导入用户
export function addOfflineExams(data) {
  return request({
    url: '/caregiver/offlineExam/caregiver-offline-exam!addOfflineExams.action',
    method: 'post',
    data: data,
  })
}

// 获取部分医院信息
export function getQualityControlDashboard(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getQualityControlDashboard.action',
    method: 'post',
    params: data,
  })
}
// 加载工作台数据
export function getWorkbenchData(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getWorkbenchData.action',
    method: 'post',
    params: data,
  })
}
// 加载指定日期的排班详情
export function getScheduleDetailByDate(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getScheduleDetailByDate.action',
    method: 'post',
    params: data,
  })
}
// 加载紧急请假列表
export function getUrgentEventsList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getUrgentEventsList.action',
    method: 'post',
    params: data,
  })
}

// 请假事件接口
export function getLeaveDetailById(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!getLeaveDetailById.action',
    method: 'post',
    params: data,
  })
}
// 投诉事件接口
export function getSurveyById(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!getSurveyById.action',
    method: 'post',
    params: data,
  })
}
// 调用接口更新投诉事件状态
export function updateSurveyById(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!updateSurveyById.action',
    method: 'post',
    params: data,
  })
}
// 获取请假记录
export function getHospitalLeaveHistory(data) {
  return request({
    url: '/caregiver/leave/caregiver-leave!getHospitalLeaveHistory.action',
    method: 'post',
    params: data,
  })
}
// 获取请假记录详情
export function getLeaveDetail(data) {
  return request({
    url: '/caregiver/leave/caregiver-leave!getLeaveDetail.action',
    method: 'post',
    params: data,
  })
}
// 抢单列表
export function getHospitalAvailableOrders(data) {
  return request({
    url: '/caregiver/order/caregiver-order!getHospitalAvailableOrders.action',
    method: 'post',
    params: data,
  })
}
// 确认接单
export function addConfirmOrder(data) {
  return request({
    url: '/caregiver/order/caregiver-order!addConfirmOrder.action',
    method: 'post',
    params: data,
  })
}
// 获取考核记录
export function getOfflineExamList(data) {
  return request({
    url: '/caregiver/offlineExam/caregiver-offline-exam!getOfflineExamList.action',
    method: 'post',
    params: data,
  })
}

// 获取医院服务对象详情
export function getServiceTargetDetail(data) {
  return request({
    url: '/hospital/serviceTarget/hospital-service-target!getServiceTargetDetail.action',
    method: 'post',
    params: data,
  })
}

// 获取服务对象详情（包含SOP流程信息）
export function getCareServiceTargetDetail(data) {
  return request({
    url: '/careServiceTarget/care-service-target!getServiceTargetDetail.action',
    method: 'post',
    params: data,
  })
}

// 获取患者SOP实例列表
export function getSopInstanceList(data) {
  return request({
    url: '/sop/instance/sop-instance!getInstanceList.action',
    method: 'get',
    params: data,
  })
}

// 获取SOP实例流程数据
export function getSopInstanceFlow(data) {
  return request({
    url: '/sop/instance/sop-instance!getInstanceFlow.action',
    method: 'get',
    params: data,
  })
}

// 获取SOP节点详情
export function getSopInstanceNodeDetail(data) {
  return request({
    url: '/sop/instance/sop-instance!getInstanceNodeDetail.action',
    method: 'post',
    params: data,
  })
}

// 更新节点腾讯会议地址
export function updateNodeMeetingUrl(data) {
  return request({
    url: '/sop/instance/sop-instance!updateNodeMeetingUrl.action',
    method: 'post',
    params: data,
  })
}

// 获取医院员工每日时间轴排班
export function getDailyTimelineSchedule(data) {
  return request({
    url: '/caregiverCompany/caregiver-company!getDailyTimelineSchedule.action',
    method: 'post',
    params: data,
  })
}

// 新预约 - 卡包预约时间设置
export function updateCardTime(data) {
  return request({
    url: '/caregiver/order/caregiver-order!updateCardTime.action',
    method: 'post',
    params: data,
  })
}

// 重新预约 - 卡包订单重新预约
export function updateRescheduleOrder(data) {
  return request({
    url: '/caregiver/order/caregiver-order!updateRescheduleOrder.action',
    method: 'post',
    params: data,
  })
}

// 编辑医院服务对象
export function updateServiceTarget(data) {
  return request({
    url: '/hospital/serviceTarget/hospital-service-target!addHospitalServiceTarget.action',
    method: 'post',
    params: data,
  })
}

// 获取服务对象历史护理任务
export function getCareDetailsByTargetId(data) {
  return request({
    url: '/caregiver/service/care-service-record!getCareDetailsByTargetId.action',
    method: 'post',
    params: data,
  })
}

// 获取SOP模板列表
export function getTemplateList(data) {
  return request({
    url: '/caregiver/sop/template/caregiver-sop-template!getTemplateList.action',
    method: 'post',
    params: data,
  })
}

// 获取服务对象的评估记录列表（医院端）
export function getPatientAssessmentRecordList(data) {
  return request({
    url: '/caregiver/hospital/caregiver-hospital!getPatientAssessmentRecordList.action',
    method: 'post',
    params: data,
  })
}

// 获取评估详情
export function getAssessmentDetail(data) {
  return request({
    url: '/assessment/record/assessment-record!getAssessmentDetail.action',
    method: 'post',
    params: data,
  })
}